import { CircleText, QuestionDisplayMode } from '@doltech/ui/lib/figma/CircleText/CircleText';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { numberToABC } from '@doltech/utils/lib/text';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';
import { Cell, Grid } from 'styled-css-grid';

import { ReadingTestSectionInstance } from '../question-data-model/TestSection/_implementations/reading-test-section.store';
import {
  CompletionWithHintAnswerQuestionInput,
  DoTestCompletionWithHintQuestionInstance,
} from '../student-do-test/model/Question/do-test-completion-with-hint-question.store';
import { useTestSubmissionStore } from '../student-do-test/model/test-submissions.hook';
import DropDownAnswerQuestion from './components/DropDownAnswerQuestion';

export interface CompletionWithHintAnswerProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestCompletionWithHintQuestionInstance;
  currentSection?: ReadingTestSectionInstance;
}

export const CompletionWithHintAnswer = observer((props: CompletionWithHintAnswerProps) => {
  const { data } = props;
  const { options, onAnswerQuestion, setParagraph, userAnswers, paragraph } = data;

  const store = useTestSubmissionStore();

  return (
    <>
      <HintBox>
        <Typography.Text variant="medium/20">Gợi ý</Typography.Text>
        <HintItemsContainer columns="repeat(auto-fill, minmax(226px, 1fr))" rowGap="12px">
          {options.map((option) => (
            <Cell key={option.key}>
              <CircleText
                displayMode={QuestionDisplayMode.QUESTION_OPTION}
                circleText={numberToABC(option.key + 1)}
                text={option.value}
              />
            </Cell>
          ))}
        </HintItemsContainer>
      </HintBox>
      <ContentBox>
        {data.heading && <Header>{data.heading}</Header>}
        <DropDownAnswerQuestion
          no={data.no}
          value={paragraph.getEditorValue()}
          blanks={paragraph.blanks as any[]}
          options={options}
          userAnswers={userAnswers}
          onSelectAnswer={(answer: CompletionWithHintAnswerQuestionInput) => {
            if (store.preventUserAction()) return;
            onAnswerQuestion(answer);
          }}
          onEditorChange={setParagraph}
        />
      </ContentBox>
    </>
  );
});

const HintItemsContainer = styled(Grid)`
  padding: 0 4px;
  margin: 16px 0 4px;
  .circle-text {
    cursor: auto;
  }
`;

const HintBox = styled.div`
  width: 100%;
  padding: 16px;
  background-color: ${colorsV2.white100};
  box-shadow: 0 16px 24px ${colorsV2.blackShadow6}, 0 2px 6px ${colorsV2.blackShadow4},
    0 0 1px ${colorsV2.blackShadow4};
  border-radius: 8px;
  margin-bottom: 16px;
`;

const ContentBox = styled.div`
  background-color: ${colorsV2.white100};
  padding: 16px;
  box-shadow: 0 2px 2px ${colorsV2.blackShadow5};
  border-radius: 16px;
`;

const Header = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 16px;
`;
